import * as Sentry from "@sentry/react";

const ENABLE_IN_DEV = false; // Set to true to test Sentry locally

export const initSentry = () => {
  const isProduction = import.meta.env.PROD;
  
  if (!isProduction && !ENABLE_IN_DEV) {
    console.log('🐛 Sentry disabled in development');
    return;
  }

  const dsn = 'https://e6ffbf946423339dff148d02f7e7de73@o4510182781026304.ingest.de.sentry.io/4510182791839824';
  
  Sentry.init({
    dsn,
    
    // Environment
    environment: isProduction ? 'production' : 'development',
    
    // Release tracking (uses git commit SHA from Vite)
    release: import.meta.env.VITE_APP_VERSION || 'unknown',
    
    // Performance Monitoring
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false, // Show text in session replays
        blockAllMedia: false, // Show images in session replays
        maskAllInputs: true, // Mask input values for privacy
      }),
    ],
    
    // Performance sample rate (100% = monitor all transactions)
    tracesSampleRate: 1.0,
    
    // Session Replay sample rate
    replaysSessionSampleRate: 0.1, // 10% of normal sessions
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
    
    // Before sending events (for PII filtering if needed)
    beforeSend(event, hint) {
      // Filter sensitive data
      if (event.request?.cookies) {
        delete event.request.cookies;
      }
      
      // Remove email addresses from error messages
      if (event.message) {
        event.message = event.message.replace(
          /[\w.-]+@[\w.-]+\.\w+/g,
          '[EMAIL_REDACTED]'
        );
      }
      
      return event;
    },
  });

  console.log('✅ Sentry initialized');
};
